import React from 'react';
import { Layout, Text, Icon, Button, Card, useTheme } from '@ui-kitten/components';
import { useQuery } from '@apollo/react-hooks';
import { Q_SURVEY_RESULTS } from '../../data/api/query/q_survey';
import { ListRenderItemInfo, View, FlatList, Platform } from 'react-native';
import { ItemTypeHeader, PollTypeHeader } from '../../components/list-items/CardItem';
import { SurveySection, Question, AnswerGroup, Answer } from '../../data/models/types';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { BasicCard, ListHeader } from '../../components/_primatives';





export function PollResultsScreen({ navigation, route }): React.ReactElement {
    const { pageSpacerHorizontal, bodyWidth, isMediumScreenOrLarger  } = useScreenDimensions();
    const params = route?.params;
    console.log({ navigation, route, params });
    const surveyId: string = params.survey || params.id;
    const DECIMAL_PLACES: number = 0;

    const { loading, error, data } = useQuery(Q_SURVEY_RESULTS, {
        variables: { survey_id: surveyId },
        fetchPolicy: 'network-only'
    });


    if (loading) {
        return <PageLoadingIndicator />;
    };
    if (error)  {
        console.log('useQuery', error);
        return <Text>Error :(</Text>;
    };
    console.log('we have data', data);

    const survey: any = data.surveys[0];
    if (!survey || survey.length === 0) {
        return <Text>Survey not found</Text>;
    };
    console.log('about to get surveyParticipantCount');
    const surveyParticipantCount: number = survey.user_answers_aggregate.aggregate.count + survey.anon_user_answers_aggregate.aggregate.count;
    console.log('survey = ', survey.survey_sections, surveyParticipantCount);

    const answerPercent = (answerCount: number) => {
        if (answerCount > 0) {
            return (answerCount / surveyParticipantCount * 100).toFixed(DECIMAL_PLACES);
        }
        return 0;
    }

    const renderItem = ({ item }: ListRenderItemInfo<SurveySection>) => {
        console.log(`const renderItem = ({ item })`, item);
        return (
            <>
                {item.questions.map((question: Question) => 
                    <BasicCard key={question.id} style={isMediumScreenOrLarger ? { marginBottom: 25 } : { borderWidth: 0 }}>
                        <Text category='h5' style={{ marginBottom: 10 }}>{survey.title || question.question_title}</Text>
                        {question.answer_groups.map((ag: AnswerGroup) => 
                            <Layout key={ag.id}>
                                {
                                    question.question_type === 'select' ? 
                                        <>
                                            {ag.possible_answers.map((answer: Answer) => {
                                                const answerCount: number = answer?.user_answers_aggregate?.aggregate?.count + answer?.anon_user_answers_aggregate?.aggregate?.count;
                                                const answerSelectedPercentage: string = `${answerPercent(answerCount)}%`
                                                return (
                                                    <View key={answer.id} style={{ marginBottom: 12 }}>
                                                        <View style={{ marginVertical: 5, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            {/* <Radio text={answer.answer_text} style={{ marginVertical: 5}} /> */}
                                                            <Text>{answer.answer_text}</Text>
                                                            <Text>{answerSelectedPercentage}</Text>
                                                        </View>
                                                        <ResultBar width={answerSelectedPercentage} />
                                                    </View>
                                                )
                                            })}
                                        </>
                                    : question.question_type === 'multiselect' ?
                                        <>
                                            {ag.possible_answers.map((answer: Answer) => {
                                                    const answerCount: number = answer?.user_answers_aggregate?.aggregate?.count + answer?.anon_user_answers_aggregate?.aggregate?.count;
                                                    const answerSelectedPercentage: string = `${answerPercent(answerCount)}%`;
                                                    return (
                                                        <View key={answer.id} style={{ marginBottom: 12 }}>
                                                            <View style={{ marginVertical: 5, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                {/* <CheckBox text={answer.answer_text} style={{ marginVertical: 5}} /> */}
                                                                <Text>{answer.answer_text}</Text>
                                                                <Text>{answerSelectedPercentage}</Text>
                                                            </View>
                                                            <ResultBar width={answerSelectedPercentage} />
                                                        </View>
                                                    )
                                                })}
                                        </>
                                    : question.question_type === 'text' ?
                                        <>
                                            {ag.possible_answers.map((answer: Answer) => {
                                                const answerCount: number = answer?.user_answers_aggregate?.aggregate?.count + answer?.anon_user_answers_aggregate?.aggregate?.count;
                                                const answerSelectedPercentage: string = `${answerPercent(answerCount)}%`
                                                return (
                                                    <View key={answer.id}>
                                                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <Button status='basic' appearance='ghost' size='small' style={{ marginLeft: -15 }}
                                                                onPress={() => navigation.navigate('SurveyQuestionResponseList', { survey_id: surveyId, question_id: question.id })}
                                                            >
                                                                View Responses
                                                            </Button>
                                                            <Text>{answerSelectedPercentage}</Text>
                                                        </View>
                                                        <ResultBar width={answerSelectedPercentage} />
                                                    </View>
                                                );
                                            })}
                                        </>
                                    : undefined
                                }                   
                            </Layout>
                        )}
                    </BasicCard>
                )}
            </>
        );
    };
    const renderHeader = () => (
        <ListHeader
            title={'Results'}
            isMediumScreenOrLarger={isMediumScreenOrLarger}
        >
            <Button
                onPress={() => navigation.navigate('PollParticipantList', { id: surveyId })}
                icon={(style) => <Icon {...style} name='people-outline' />}
            >
                {isMediumScreenOrLarger ? `View Participants` : ``}
            </Button>
            {/* <Text category='s1' style={{ marginBottom: 20 }}>{`Total Polls Completed: ${surveyParticipantCount}`}</Text> */}
        </ListHeader>
    );
    const renderHeader2 = () => (
        <View style={{ marginVertical: 20, paddingHorizontal: 23 }}>
            <PollTypeHeader />
            <Text category='h1'>{'Poll Results'}</Text>
            <Text category='s1' style={{ marginBottom: 20 }}>{`Total Polls Completed: ${surveyParticipantCount}`}</Text>
            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap' }}>
                <Button
                    onPress={() => navigation.navigate('PollParticipantList', { id: surveyId })}
                    icon={(style) => <Icon {...style} name='people-outline' />}
                >
                    {`View Participants`}
                </Button>
            </View>
        </View>
    );

    const renderFooter = () => (
        <View style={{ height: 100 }}>
        </View>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ borderWidth: 0 }}>
            <Text category='p1'>{'This poll doesn\'t have any submissions yet'}</Text>
        </BasicCard>
    );
    const _keyExtractor = (item) => item.id;

    return (
        <Layout level='1' style={{ flex: 1 }}>
            <FlatList
                data={survey.survey_sections}
                renderItem={renderItem}
                keyExtractor={_keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
                ListEmptyComponent={listEmptyComponent}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
            />
        </Layout>
    );
    
}


const BAR_HEIGHT: number = 30;

function ResultBar({ width }: { width: string }) {
    const theme = useTheme();
    return (
        <View style={{
            width: '100%',
            backgroundColor: 'lightgray',
            // backgroundColor: theme['color-primary-default'] + '22',
            borderRadius: BAR_HEIGHT
        }}>
            <View
                style={{
                    height: BAR_HEIGHT,
                    width: width,
                    backgroundColor: theme['color-primary-default'],
                    borderRadius: BAR_HEIGHT,
                }}
            />
        </View>
        
    );
}

